import React from 'react';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import { Button } from './button';

/**
 * Componente de Paginação Reutilizável
 * 
 * Props:
 * - page: número da página atual
 * - pages: total de páginas
 * - total: total de items
 * - limit: items por página
 * - onPageChange: callback quando a página muda
 * - showInfo: mostrar informação de "X de Y items" (default: true)
 */
export const Pagination = ({ 
  page = 1, 
  pages = 1, 
  total = 0, 
  limit = 50, 
  onPageChange,
  showInfo = true,
  className = ''
}) => {
  const handleFirst = () => onPageChange?.(1);
  const handlePrev = () => page > 1 && onPageChange?.(page - 1);
  const handleNext = () => page < pages && onPageChange?.(page + 1);
  const handleLast = () => onPageChange?.(pages);

  // Calcular range de items exibidos
  const start = Math.min((page - 1) * limit + 1, total);
  const end = Math.min(page * limit, total);

  if (pages <= 1 && !showInfo) return null;

  return (
    <div className={`flex items-center justify-between gap-4 ${className}`}>
      {showInfo && (
        <span className="text-sm text-muted-foreground">
          {total > 0 ? (
            <>Mostrando {start}-{end} de {total} itens</>
          ) : (
            'Nenhum item'
          )}
        </span>
      )}
      
      {pages > 1 && (
        <div className="flex items-center gap-1">
          <Button
            variant="outline"
            size="sm"
            onClick={handleFirst}
            disabled={page <= 1}
            className="h-8 w-8 p-0"
          >
            <ChevronsLeft className="h-4 w-4" />
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={handlePrev}
            disabled={page <= 1}
            className="h-8 w-8 p-0"
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
          
          <span className="px-3 text-sm text-muted-foreground">
            Página {page} de {pages}
          </span>
          
          <Button
            variant="outline"
            size="sm"
            onClick={handleNext}
            disabled={page >= pages}
            className="h-8 w-8 p-0"
          >
            <ChevronRight className="h-4 w-4" />
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={handleLast}
            disabled={page >= pages}
            className="h-8 w-8 p-0"
          >
            <ChevronsRight className="h-4 w-4" />
          </Button>
        </div>
      )}
    </div>
  );
};

export default Pagination;
